import React from 'react';
import './VerifyCriticalInformationForm.sass';
import * as A from 'ApplicationEntry/models/Application';
import {matchVerifyCriticalInformationByType} from 'ApplicationEntry/models/VerifyCriticalInformation';
import OrdinaryVerifyCriticalInformationForm from './OrdinaryVerifyCriticalInformationForm';
import GroupVerifyCriticalInformationForm from './GroupVerifyCriticalInformation';
import NewYorkVerifyCriticalInformationForm from './NewYorkVerifyCriticalInformation';

type VerifyCriticalInformationFormProps = {
  onCancel: () => void;
  application: A.ValidApplication | A.InvalidApplication;
  onSaveToLife70: () => void;
};

export const VerifyCriticalInformationForm = ({
  application,
  onCancel,
  onSaveToLife70,
}: VerifyCriticalInformationFormProps) =>
  A.matchApplicationByType({
    Ordinary: ordinaryApplication =>
      matchVerifyCriticalInformationByType({
        Ordinary: verifyCriticalInformation => (
          <OrdinaryVerifyCriticalInformationForm
            agentList={application.agentList}
            applicantDemographics={ordinaryApplication.applicantDemographics}
            billingAgent={ordinaryApplication.billingAgent}
            caseDetails={ordinaryApplication.caseDetails}
            verifyCriticalInformation={verifyCriticalInformation}
            onCancel={onCancel}
            onSaveToLife70={onSaveToLife70}
          />
        ),
        _: () => <>Empty</>,
      })(application.verifyCriticalInformation),
    Group: groupApplication =>
      matchVerifyCriticalInformationByType({
        Group: verifyCriticalInformation => (
          <GroupVerifyCriticalInformationForm
            agentList={application.agentList}
            applicantDemographics={groupApplication.applicantDemographics}
            billingAgent={groupApplication.billingAgent}
            caseDetails={groupApplication.caseDetails}
            verifyCriticalInformation={verifyCriticalInformation}
            onCancel={onCancel}
            onSaveToLife70={onSaveToLife70}
          />
        ),
        _: () => <>Empty</>,
      })(application.verifyCriticalInformation),
    NewYork: newYorkApplication =>
      matchVerifyCriticalInformationByType({
        NewYork: verifyCriticalInformation => (
          <NewYorkVerifyCriticalInformationForm
            agentList={application.agentList}
            applicantDemographics={newYorkApplication.applicantDemographics}
            billingAgent={newYorkApplication.billingAgent}
            caseDetails={newYorkApplication.caseDetails}
            verifyCriticalInformation={verifyCriticalInformation}
            onCancel={onCancel}
          />
        ),
        _: () => <>Empty</>,
      })(application.verifyCriticalInformation),
    Undetermined: () => <>Empty</>,
  })(application);

export default VerifyCriticalInformationForm;
